import { render } from "./Reports-history.vue?vue&type=template&id=3c81a7d1"
import script from "./Reports-history.vue?vue&type=script&lang=js"
export * from "./Reports-history.vue?vue&type=script&lang=js"

import "@/styles/profile/users/reports.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__